<template>
	<div class="acessar-ata-itens">
		<menu-acoes
			class="botao-tamanho-arp"
			:nome-botao="placeholder"
			:nome="placeholder"
			cor-icone="--v-error-base"
			icone-secondary="arrow_drop_down"
			:outlined="true"
			:block="block"
			corDeFundo="grey"
			:acoes-menu="montarItens"
			tamanho-icone-menu="18px"
			@aditar-itens="$emit('aditar-itens')"
			@excluir-itens="$emit('excluir-itens')"
			@bloquear-itens="$emit('bloquear-itens')"
			@prazo-entrega="$emit('prazo-entrega')"
		>
		</menu-acoes>
	</div>
</template>
<script>
import { permissoes } from '@/core/constants'
import validacaoAta from '@/views/mixins/validacaoAta'
import permissoesMixin from '@/views/mixins/permissoes-mixin'
import { mapState } from 'vuex'

export default {
	name: 'acessar-ata-itens-btn-mais-acoes',
	mixins: [validacaoAta, permissoesMixin],
	props: {
		block: {
			type: Boolean,
		},
	},
	data() {
		return {
			placeholder: 'MAIS AÇÕES',

			itensAtaEfetivada: [
				this.criarItemAta('Prazo de Entrega', 'event', 'prazo-entrega', this.usuarioPermissaoAlterar, true),
				this.criarItemAta('Bloquear Itens', 'cancel', 'bloquear-itens', permissoes.itemAtaBloquear),
				this.criarItemAta('Excluir', 'delete', 'excluir-itens', permissoes.itemAtaExcluir),
			],

			itensAtaNaoEfetivada: [
				this.criarItemAta('Prazo de Entrega', 'event', 'prazo-entrega', this.usuarioPermissaoAlterar, true),
				this.criarItemAta('Excluir', 'delete', 'excluir-itens', permissoes.itemAtaExcluir),
			],
		}
	},
	computed: {
		...mapState({
			informacoesAta: (state) => state.ata.informacoesAta,
			usuarioPermissaoAlterar: (state) => state.ata.informacoesAta.usuarioPermissaoAlterar,
		}),

		montarItens() {
			return this.informacoesAta && this.estaEfetivado(this.informacoesAta)
				? this.itensAtaEfetivada
				: this.itensAtaNaoEfetivada
		},
	},
	methods: {
		criarItemAta(titulo, iconeNome, evento, authorization, isVisible) {
			return {
				titulo,
				icone: {
					nome: iconeNome,
				},
				evento,
				authorization,
				isVisible: () => !this.isAtaAdesao || isVisible,
			}
		},
	},
}
</script>
<style lang="stylus">
.botao-tamanho-arp .v-btn
	width (116 / 16)rem !important
</style>
